<template>
  <section class="co-bg-striped">
    <div class="te-thousand-wrap flex flex-col items-center justify-center px-4 md:flex-row">
      <div class="items-center md:flex">
        <div class="hidden md:my-5 md:mr-4 md:block">
          <img
            src="~/assets/images/Te/TeCommon/Banner/Thousand/people-color.webp"
            alt="1000案件イラスト"
            width="154"
            height="113"
            loading="lazy"
          >
        </div>
        <div class="te-thousand-title co-display-7 mb-0 py-4 text-center font-bold text-co-gray-600 md:mb-1 md:text-left">
          多数の案件<span class="co-display-11 font-bold">から</span>
          <br>
          <span class="co-marker-thousand-1">あなたにあった</span>
          <span class="co-marker-thousand-1">仕事</span>
          <span class="co-display-11 font-bold">を紹介</span>
        </div>
      </div>
      <div class="te-thousand-text mb-3 mt-1 flex justify-center gap-2">
        <img
          src="~/assets/images/Te/TeCommon/Banner/Thousand/icon-project-guarantee.svg"
          alt="案件保証アイコン"
          width="80"
          height="80"
          loading="lazy"
          class="te-icon-thousand-guarantee"
        >
        <div class="co-display-9 font-bold leading-none text-co-gray-600">
          <h5 class="co-display-12 mb-0 font-normal text-co-gray-600">
            初心者向けのトライアル案件からできる
          </h5>
          副業案件<span class="co-marker-thousand-1 co-display-6 mx-1 font-bold">50,000<span class="co-display-10 font-bold">円分</span></span>保証
          <p class="co-display-14 mt-3 max-w-[300px] font-normal leading-normal text-co-gray-500">
            ※2024年8月5日以降のお申し込みされた方に受講開始から1年以内のみ保証
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-thousand-title {
  line-height: 1.25;
}

.te-thousand-wrap {
  gap: 1rem;
  @media (min-width: 768px) {
    gap: 1.25rem;
  }
  @media (min-width: 992px) {
    gap: 2.5rem;
  }
}

/* // アイコンのサイズ */
.te-icon-thousand-guarantee {
  width: 3.75rem;
  height: 3.75rem;
  @media (min-width: 992px) {
    width: 5rem;
    height: 5rem;
  }
}

/* // マーカー */
.co-marker-thousand-1 {
  background: linear-gradient(transparent 70%, #fff0a1 0);
}

.te-thousand-text {
  line-height: 1.5;
}
</style>
